import API from "serviceshift-ui/api-client";

export default {
  deleteJobPhoto(_, params) {
    const { jobId, id } = params;
    return API.job.deletePhoto(jobId, id);
  },
  deleteJobDocument(_, params) {
    const { jobId, id } = params;
    return API.job.deleteDocument(jobId, id);
  },
  uploadJobDocument(_, params) {
    const { jobId, data } = params;
    return API.job.uploadDocument(jobId, { body: data });
  },
  updateJobDocumentVisibility(_, params) {
    const { jobId, docId, ...visibility } = params;
    return API.job.updateDocumentVisibility(jobId, docId, visibility);
  },
  updateJobPhotoVisibility(_, params) {
    const { jobId, photoId, ...visibility } = params;
    return API.job.updatePhotoVisibility(jobId, photoId, visibility);
  }
};
